<div class="col-md-12">
    <button type="button" tooltipClass="fadeInAnimation" placement="top" class="btn btn-sm btn-flat-success" rippleEffect (click)="navigateToSaveTicket()">
        <span data-feather="plus" [class]="'mr-25'"></span>{{'AddSubTicket' | translate}}
    </button>
</div>
<div id="subTicketSection">
    <div style="text-align: center; color: blue;" *ngFor="let item of subTicketList.data">
        <a class="mt-50" (click)="getTicketByTicketId(item)">{{item}}</a>
    </div>
</div>
